import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=3c348a7a&scoped=true&v-once=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c348a7a",
  null
  
)

export default component.exports